import { locations } from "../../common/redux/action_locations";
import {

} from "./constants";
import { CFAuthGetRef, CFAuthPutRef  } from "auth";
import moment from "moment-timezone";

export function fetchCurrentWorkDayMUAction(filters) {
    return {
        type: "FETCH_CURRENT_WORK_DAY_MU",
        fetchCall: fetchCurrentWorkDayMU,
        receivedAction: filters.isDetailView ? receivedDetailedCurrentWorkDayMU : receivedCurrentWorkDayMU,
        data: {
            filters,
            locations
        }
    };
}

function fetchCurrentWorkDayMU(filters) {
    return CFAuthGetRef({
        url: process.env.REACT_APP_SCORECARD_API_URL + "/api/ScorecardMetric",
        params: {
			groupingType: filters.groupingType
        },
        customQueryParams: filters.customQueryParams,
        originURL: process.env.PUBLIC_URL,
        loaderName: "fetchCurrentWorkDayMU"
    });
}

export function receivedCurrentWorkDayMU(data, isUpsert = false) {
    let uiModelData = {}
    
    if(data && data.length > 0) {
        data.forEach(item => {
            
            let itemObject = {}
            
            itemObject["Name"] = item.name;
            itemObject["CustomerClosing"] = item.customerClosing;
            itemObject["SalesClosing"] = item.salesClosing;
            itemObject["UnavailableRate"] = item.unavailableRate;
            itemObject["TotalSales"] = item.sales;
            itemObject["DeliveredCalls"] = item.deliveredCalls;
            itemObject["ItemID"] = item.id;
            itemObject["DateUpdated"] = item.dateUpdated;
            
            uiModelData[item.id.toString()] = itemObject;
        });
    }
    
    return {
		type: "CURRENT_WORK_DAY_MU_RECEIVED_DATA",
        currentWorkDayDataMU: {
            uiModelData,
            isUpsert
        }
	};
}

function receivedDetailedCurrentWorkDayMU(data) {
    let uiModelData = {}
    let isUpsert = true;

    if(data && data.length > 0) {
        data.forEach(item => {
            
            let itemObject = {}
            
            itemObject["Name"] = item.name;
            itemObject["CustomerClosing"] = item.customerClosing;
            itemObject["SalesClosing"] = item.salesClosing;
            itemObject["UnavailableRate"] = item.unavailableRate;
            itemObject["TotalSales"] = item.sales;
            itemObject["DeliveredCalls"] = item.deliveredCalls;
            itemObject["ItemID"] = item.id;
            itemObject["DateUpdated"] = item.dateUpdated;
            
            uiModelData[item.id.toString()] = itemObject;
        });
    }
    
    return {
		type: "CURRENT_WORK_DAY_MU_RECEIVED_DATA",
        currentWorkDayDataMU: {
            uiModelData,
            isUpsert
        }
	};
}

export function fetchCurrentWorkDayAgentAction(filters) {  
    return {
        type: "FETCH_CURRENT_WORK_DAY_AGENT",
        fetchCall: fetchCurrentWorkDayAgent,
        receivedAction: filters.isDetailView ? receivedDetailedCurrentWorkDayAgent : receivedCurrentWorkDayAgent,
        data: {
            filters,
            locations
        }
    };
}

function fetchCurrentWorkDayAgent(filters) {
    return CFAuthGetRef({
        url: process.env.REACT_APP_SCORECARD_API_URL + "/api/ScorecardMetric",
        params: {
			groupingType: filters.groupingType
        },
        customQueryParams: filters.customQueryParams,
        originURL: process.env.PUBLIC_URL,
        loaderName: "fetchCurrentWorkDayAgent"
    });
}

export function receivedCurrentWorkDayAgent(data, isUpsert = false) {
    let uiModelData = {}
    
    if(data && data.length > 0) {
        data.forEach(item => {
            
            let itemObject = {}
            
            itemObject["Name"] = item.name;
            itemObject["CustomerClosing"] = item.customerClosing;
            itemObject["SalesClosing"] = item.salesClosing;
            itemObject["UnavailableRate"] = item.unavailableRate;
            itemObject["TotalSales"] = item.sales;
            itemObject["DeliveredCalls"] = item.deliveredCalls;
            itemObject["ItemID"] = item.id;
            itemObject["DateUpdated"] = item.dateUpdated;

            uiModelData[item.id.toString()] = itemObject;
        });
    }

    return {
		type: "CURRENT_WORK_DAY_AGENT_RECEIVED_DATA",
        currentWorkDayDataAgent: {
            uiModelData,
            isUpsert
        }
    };
}

function receivedDetailedCurrentWorkDayAgent(data) {
    let uiModelData = {}
    let isUpsert = true;

    if(data && data.length > 0) {
        data.forEach(item => {
            
            let itemObject = {}
            
            itemObject["Name"] = item.name;
            itemObject["CustomerClosing"] = item.customerClosing;
            itemObject["SalesClosing"] = item.salesClosing;
            itemObject["UnavailableRate"] = item.unavailableRate;
            itemObject["TotalSales"] = item.sales;
            itemObject["DeliveredCalls"] = item.deliveredCalls;
            itemObject["ItemID"] = item.id;
            itemObject["DateUpdated"] = item.dateUpdated;

            uiModelData[item.id.toString()] = itemObject;
        });
    }
    
    return {
		type: "CURRENT_WORK_DAY_AGENT_RECEIVED_DATA",
        currentWorkDayDataAgent: {
            uiModelData,
            isUpsert
        }
	};
}

export function fetchCurrentWorkDayTeamAction(filters) {  
    return {
        type: "FETCH_CURRENT_WORK_DAY_TEAM",
        fetchCall: fetchCurrentWorkDayTeam,
        receivedAction: filters.isDetailView ? receivedDetailedCurrentWorkDayTeam : receivedCurrentWorkDayTeam,
        data: {
            filters,
            locations
        }
    };
}

function fetchCurrentWorkDayTeam(filters) {
    return CFAuthGetRef({
        url: process.env.REACT_APP_SCORECARD_API_URL + "/api/ScorecardMetric",
        params: {
			groupingType: filters.groupingType
        },
        customQueryParams: filters.customQueryParams,
        originURL: process.env.PUBLIC_URL,
        loaderName: "fetchCurrentWorkDayTeam"
    });
}

export function receivedCurrentWorkDayTeam(data, isUpsert = false) {

    let uiModelData = {}
    
    if(data && data.length > 0) {
        data.forEach(item => {
            
            let itemObject = {}
            
            itemObject["Name"] = item.name;
            itemObject["CustomerClosing"] = item.customerClosing;
            itemObject["SalesClosing"] = item.salesClosing;
            itemObject["UnavailableRate"] = item.unavailableRate;
            itemObject["TotalSales"] = item.sales;
            itemObject["DeliveredCalls"] = item.deliveredCalls;
            itemObject["ItemID"] = item.id;
            itemObject["DateUpdated"] = item.dateUpdated;

            uiModelData[item.id.toString()] = itemObject;
        });
    }
    
    return {
		type: "CURRENT_WORK_DAY_TEAM_RECEIVED_DATA",
		currentWorkDayDataTeam: {
            uiModelData,
            isUpsert
        }
	};
}

function receivedDetailedCurrentWorkDayTeam(data) {

    let uiModelData = {}
    let isUpsert = true;

    if(data && data.length > 0) {
        data.forEach(item => {
            
            let itemObject = {}
            
            itemObject["Name"] = item.name;
            itemObject["CustomerClosing"] = item.customerClosing;
            itemObject["SalesClosing"] = item.salesClosing;
            itemObject["UnavailableRate"] = item.unavailableRate;
            itemObject["TotalSales"] = item.sales;
            itemObject["DeliveredCalls"] = item.deliveredCalls;
            itemObject["ItemID"] = item.id;
            itemObject["DateUpdated"] = item.dateUpdated;
            
            uiModelData[item.id.toString()] = itemObject;
        });
    }
    
    return {
		type: "CURRENT_WORK_DAY_TEAM_RECEIVED_DATA",
		currentWorkDayDataTeam: {
            uiModelData,
            isUpsert
        }
	};
}

export function fetchPreviousWorkDayMUAction(filters) {
    return {
        type: "FETCH_PREVIOUS_WORK_DAY_MU",
        fetchCall: fetchPreviousWorkDayMU,
        receivedAction: receivedPreviousWorkDayMU,
        data: {
            filters,
            locations
        }
    };
}

function fetchPreviousWorkDayMU(filters) {
    return CFAuthGetRef({
        url: process.env.REACT_APP_SCORECARD_API_URL + "/odata/AgentScorecardDailyManagementUnit?$filter=AgentScorecardId in (" + filters.cardIds + ") and ManagementUnitId in (" + filters.ids + ")",
        originURL: process.env.PUBLIC_URL,
        loaderName: "fetchPreviousWorkDayMU"
    });
}

function receivedPreviousWorkDayMU(data) {
    let uiModelData = [];
    let result = getGroupedData(data, 'mu');

    if(result && result.length > 0) {
        result.forEach(item => {
            uiModelData.push ({
                Name: item.itemName ? item.itemName : "n/a",
                CustomerClosing: item.CustomerClosing ? item.CustomerClosing : 0,
                SalesClosing: item.SalesClosing ? item.SalesClosing : 0,
                UnavailableRate: item.UnavailableRate ? item.UnavailableRate : 0,
                TotalSales: item.Sales ? item.Sales : 0,
                DeliveredCalls: item.DeliveredCalls ? item.DeliveredCalls : 0,
                ItemID: item.itemId ? item.itemId : 0
            });
        });
    }

    return {
		type: "PREVIOUS_WORK_DAY_MU_RECEIVED_DATA",
		previousWorkDayDataMU: uiModelData
	};
}

export function fetchPreviousWorkDayAgentAction(filters) {
    return {
        type: "FETCH_PREVIOUS_WORK_DAY_AGENT",
        fetchCall: fetchPreviousWorkDayAgent,
        receivedAction: receivedPreviousWorkDayAgent,
        data: {
            filters,
            locations
        }
    };
}

function fetchPreviousWorkDayAgent(filters) {
    return CFAuthGetRef({
        url: process.env.REACT_APP_SCORECARD_API_URL + "/odata/AgentScorecardDaily?$filter=AgentScorecardId in (" + filters.cardIds + ") and AgentId in (" + filters.ids + ")",
        originURL: process.env.PUBLIC_URL,
        loaderName: "fetchPreviousWorkDayAgent"
    });
}

function receivedPreviousWorkDayAgent(data) {
    let uiModelData = [];
    let result = getGroupedData(data, 'agent');

    if(result && result.length > 0) {
        result.forEach(item => {
            uiModelData.push ({
                Name: item.itemName ? item.itemName : "n/a",
                CustomerClosing: item.CustomerClosing ? item.CustomerClosing : 0,
                SalesClosing: item.SalesClosing ? item.SalesClosing : 0,
                UnavailableRate: item.UnavailableRate ? item.UnavailableRate : 0,
                TotalSales: item.Sales ? item.Sales : 0,
                DeliveredCalls: item.DeliveredCalls ? item.DeliveredCalls : 0,
                ItemID: item.itemId ? item.itemId : 0
            });
        });
    }

    return {
		type: "PREVIOUS_WORK_DAY_AGENT_RECEIVED_DATA",
		previousWorkDayDataAgent: uiModelData
	};
}

Array.prototype.groupBy = function(prop) {
    return this.reduce(function(groups, item) {
        const val = item[prop];
        groups[val] = groups[val] || [];
        groups[val].push(item);
        return groups;
    }, {});
};

function getGroupedData(data, type) {
    let groupType = "";
    let groupName = "";
    let result = [];

    switch(type){
        case 'agent':
            groupType = "AgentId";
            groupName = "AgentName";
        break;
        case 'team':
            groupType = "TeamId";
            groupName = "TeamName";
        break;
        case 'mu':
            groupType = "ManagementUnitId";
            groupName = "ManagementUnitName";
        break;
        // no default
    }

    if(data.value && data.value.length > 0) {
        let groupedByType = data.value.groupBy(groupType);
        
        if(groupedByType) {
            Object.keys(groupedByType).forEach(function(itemId) {
                
                let groupedByCardId = groupedByType[itemId].groupBy("AgentScorecardId");

                let max = new moment("1000/01/01");
                
                let agentData = [];

                Object.keys(groupedByCardId).forEach(function(cardId) {
                    
                    let obj = groupedByCardId[cardId];

                    let result = [];

                    Object.keys(obj).forEach(function(item) {
                        
                        let currentObject = obj[item];

                        let currentDateKey = moment(currentObject.DateKey);
                        
                        if(currentDateKey >= max) {
                            max = item;
                            result["scorecardValue"] = currentObject.AgentScorecardValue;
                            agentData["itemName"] = currentObject[groupName] ? currentObject[groupName] : '';
                        }
                    });
                    
                    if(cardId === "1") {
                        agentData["CustomerClosing"] = result["scorecardValue"];
                    }
                    else if (cardId === "2") {
                        agentData["SalesClosing"] = result["scorecardValue"];
                    }
                    else if (cardId === "15") {
                        agentData["DeliveredCalls"] = result["scorecardValue"];
                    }
                    else if (cardId === "10") {
                        agentData["Sales"] = result["scorecardValue"];
                    }
                    else if (cardId === "9") {
                        agentData["UnavailableRate"] = result["scorecardValue"];
                    }
                })

                agentData["itemId"] = itemId;
                result.push(agentData);
            })
        }
    }
    return result;
}

export function fetchPreviousWorkDayTeamAction(filters) {
    return {
        type: "FETCH_PREVIOUS_WORK_DAY_TEAM",
        fetchCall: fetchPreviousWorkDayTeam,
        receivedAction: receivedPreviousWorkDayTeam,
        data: {
            filters,
            locations
        }
    };
}

function fetchPreviousWorkDayTeam(filters) {
    return CFAuthGetRef({
        url: process.env.REACT_APP_SCORECARD_API_URL + "/odata/AgentScorecardDailyTeam?$filter=AgentScorecardId in (" + filters.cardIds + ") and TeamId in (" + filters.ids + ")",
        originURL: process.env.PUBLIC_URL,
        loaderName: "fetchPreviousWorkDayTeam"
    });
}

function receivedPreviousWorkDayTeam(data) {
    let uiModelData = [];
    let result = getGroupedData(data, 'team');

    if(result && result.length > 0) {
        result.forEach(item => {
            uiModelData.push ({
                Name: item.itemName ? item.itemName : "n/a",
                CustomerClosing: item.CustomerClosing ? item.CustomerClosing : 0,
                SalesClosing: item.SalesClosing ? item.SalesClosing : 0,
                UnavailableRate: item.UnavailableRate ? item.UnavailableRate : 0,
                TotalSales: item.Sales ? item.Sales : 0,
                DeliveredCalls: item.DeliveredCalls ? item.DeliveredCalls : 0,
                ItemID: item.itemId ? item.itemId : 0
            });
        });
    }

    return {
		type: "PREVIOUS_WORK_DAY_TEAM_RECEIVED_DATA",
		previousWorkDayDataTeam: uiModelData
	};
}

export function fetchThirtyDayAverageMUAction(filters) {
    return {
        type: "FETCH_THIRTY_DAY_AVERAGE_MU",
        fetchCall: fetchThirtyDayAverageMU,
        receivedAction: receivedThirtyDayAverageMU,
        data: {
            filters,
            locations
        }
    };
}

function fetchThirtyDayAverageMU(filters) {
    return CFAuthGetRef({
        url: process.env.REACT_APP_SCORECARD_API_URL + "/odata/AgentScorecardThirtyDayManagementUnit?$filter=AgentScorecardId in (" + filters.cardIds + ") and ManagementUnitId in (" + filters.ids + ")",
        originURL: process.env.PUBLIC_URL,
        loaderName: "fetchThirtyDayAverageMU"
    });
}

function receivedThirtyDayAverageMU(data) {
    let uiModelData = [];
    let result = getGroupedData(data, 'mu');

    if(result && result.length > 0) {
        result.forEach(item => {
            uiModelData.push ({
                Name: item.itemName ? item.itemName : "n/a",
                CustomerClosing: item.CustomerClosing ? item.CustomerClosing : 0,
                SalesClosing: item.SalesClosing ? item.SalesClosing : 0,
                UnavailableRate: item.UnavailableRate ? item.UnavailableRate : 0,
                TotalSales: item.Sales ? item.Sales : 0,
                DeliveredCalls: item.DeliveredCalls ? item.DeliveredCalls : 0,
                ItemID: item.itemId ? item.itemId : 0
            });
        });
    }

    return {
		type: "THIRTY_DAY_AVERAGE_MU_RECEIVED_DATA",
		thirtyDayAverageDataMU: uiModelData
	};
}

export function fetchThirtyDayAverageAgentAction(filters) {
    return {
        type: "FETCH_THIRTY_DAY_AVERAGE_AGENT",
        fetchCall: fetchThirtyDayAverageAgent,
        receivedAction: receivedThirtyDayAverageAgent,
        data: {
            filters,
            locations
        }
    };
}

function fetchThirtyDayAverageAgent(filters) {
    return CFAuthGetRef({
        url: process.env.REACT_APP_SCORECARD_API_URL + "/odata/AgentScorecardThirtyDay?$filter=AgentScorecardId in (" + filters.cardIds + ") and AgentId in (" + filters.ids + ")",
        originURL: process.env.PUBLIC_URL,
        loaderName: "fetchThirtyDayAverageAgent"
    });
}

function receivedThirtyDayAverageAgent(data) {
    let uiModelData = [];
    let result = getGroupedData(data, 'agent');
    
    if(result && result.length > 0) {
        result.forEach(item => {
            uiModelData.push ({
                Name: item.itemName ? item.itemName : "n/a",
                CustomerClosing: item.CustomerClosing ? item.CustomerClosing : 0,
                SalesClosing: item.SalesClosing ? item.SalesClosing : 0,
                UnavailableRate: item.UnavailableRate ? item.UnavailableRate : 0,
                TotalSales: item.Sales ? item.Sales : 0,
                DeliveredCalls: item.DeliveredCalls ? item.DeliveredCalls : 0,
                ItemID: item.itemId ? item.itemId : 0
            });
        });
    }

    return {
		type: "THIRTY_DAY_AVERAGE_AGENT_RECEIVED_DATA",
		thirtyDayAverageDataAgent: uiModelData
	};
}

export function fetchThirtyDayAverageTeamAction(filters) {
    return {
        type: "FETCH_THIRTY_DAY_AVERAGE_TEAM",
        fetchCall: fetchThirtyDayAverageTeam,
        receivedAction: receivedThirtyDayAverageTeam,
        data: {
            filters,
            locations
        }
    };
}

function fetchThirtyDayAverageTeam(filters) {
    return CFAuthGetRef({
        url: process.env.REACT_APP_SCORECARD_API_URL + "/odata/AgentScorecardThirtyDayTeam?$filter=AgentScorecardId in (" + filters.cardIds + ") and TeamId in (" + filters.ids + ")",
        originURL: process.env.PUBLIC_URL,
        loaderName: "fetchThirtyDayAverageTeam"
    });
}

function receivedThirtyDayAverageTeam(data) {
    let uiModelData = [];
    let result = getGroupedData(data, 'team');

    if(result && result.length > 0) {
        result.forEach(item => {
            uiModelData.push ({
                Name: item.itemName ? item.itemName : "n/a",
                CustomerClosing: item.CustomerClosing ? item.CustomerClosing : 0,
                SalesClosing: item.SalesClosing ? item.SalesClosing : 0,
                UnavailableRate: item.UnavailableRate ? item.UnavailableRate : 0,
                TotalSales: item.Sales ? item.Sales : 0,
                DeliveredCalls: item.DeliveredCalls ? item.DeliveredCalls : 0,
                ItemID: item.itemId ? item.itemId : 0
            });
        });
    }

    return {
		type: "THIRTY_DAY_AVERAGE_TEAM_RECEIVED_DATA",
		thirtyDayAverageDataTeam: uiModelData
	};
}

export function applyFilterAction() {
    let displayTable = true;
    
    return {
        type: "DISPLAY_TABLE",
        displayTable: displayTable
    };
}

export function clearFilterAction() {
    let displayTable = false;
    
    return {
        type: "CLEAR_TABLE",
        displayTable: displayTable
    };
}

export function notifySubscribersOfSelectedItems(muSelectedItems, teamSelectedItems, agentSelectedItems) {
    
    let _muSelectedItems = muSelectedItems ? JSON.parse(JSON.stringify(muSelectedItems)) : [];
    let _teamSelectedItems = teamSelectedItems ? JSON.parse(JSON.stringify(teamSelectedItems)) : [];
    let _agentSelectedItems = agentSelectedItems ? JSON.parse(JSON.stringify(agentSelectedItems)) : [];
    
    
    return {
        type: "NotifySubscriberOfSelectedItems",
        muSelectedItems: _muSelectedItems,
        teamSelectedItems: _teamSelectedItems,
        agentSelectedItems: _agentSelectedItems
    };
}


export function updateUserToSelectedItemCacheAction(filters) {
    return {
        type: "UPDATE_USER_TO_SELECTED_ITEM_CACHE",
        fetchCall: updateUserToSelectedItemCache,
        receivedAction: handleUserToSelectedItemCache,
        data: {
            filters,
            locations
        }
    };
}

function updateUserToSelectedItemCache(filters) {
    return CFAuthPutRef({
		url: process.env.REACT_APP_SCORECARD_API_URL + '/api/ScorecardCache',
		body: filters.Data
	});
}

function handleUserToSelectedItemCache(data) {
    if(data.errors) {
        return {
            type: "UPDATE_USER_TO_SELECTED_ITEM_CACHE_RESPONSE",
            updateUserToSelectedItemCache: data.errors
        };
    } else {
		return {
            type: "UPDATE_USER_TO_SELECTED_ITEM_CACHE_RESPONSE",
            updateUserToSelectedItemCache: []
        };
	}
}

function mapDayOverDay(currentData, previousData) {
    if (!currentData || !previousData || previousData.length < 1) return currentData;
    const newCurrentData = { ...currentData };

    previousData.forEach(data => {
        const id = parseInt(data.ItemID, 10);
        
        if (newCurrentData.uiModelData[id]) {
            const newCurrentModelData = newCurrentData.uiModelData[id];
            //Customer Closing
            if (!Number.isNaN(data.CustomerClosing) && !Number.isNaN(newCurrentModelData.CustomerClosing)) {
                const DOD = (newCurrentModelData.CustomerClosing - data.CustomerClosing) / data.CustomerClosing * 100;
                newCurrentModelData.CustomerClosingDOD = DOD;
            }
            //Sales Closing
            if (!Number.isNaN(data.SalesClosing) && !Number.isNaN(newCurrentModelData.SalesClosing)) {
                const DOD = (newCurrentModelData.SalesClosing - data.SalesClosing) / data.SalesClosing * 100;
                newCurrentModelData.SalesClosingDOD = DOD;
            }
            //Unavailable Rate
            if (!Number.isNaN(data.UnavailableRate) && !Number.isNaN(newCurrentModelData.UnavailableRate)) {
                const DOD = (newCurrentModelData.UnavailableRate - data.UnavailableRate) / data.UnavailableRate * 100
                newCurrentModelData.UnavailableRateDOD = DOD;
            }
            //Total Sales
            if (!Number.isNaN(data.TotalSales) && !Number.isNaN(newCurrentModelData.TotalSales)) {
                const parsedDataValue = parseInt(data.TotalSales.replace(/,/g, ''), 10);
                const DOD = (newCurrentModelData.TotalSales - parsedDataValue) / parsedDataValue * 100;

                newCurrentModelData.TotalSalesDOD = DOD;
            }
            //Delivered Calls
            if (!Number.isNaN(data.DeliveredCalls) && !Number.isNaN(newCurrentModelData.DeliveredCalls)) {
                const parsedDataValue = parseInt(data.DeliveredCalls.replace(/,/g, ''), 10);
                const DOD = (newCurrentModelData.DeliveredCalls - parsedDataValue) / parsedDataValue * 100;
                newCurrentModelData.DeliveredCallsDOD = DOD;
            }

            newCurrentData.uiModelData[id] = newCurrentModelData;
        }
    });

    return newCurrentData;
}

export function reducer(state, action) {
    let currentWorkDayDataMU = null;
    let currentWorkDayDataAgent = null;
    let currentWorkDayDataTeam = null;
    switch (action.type) {
        case "CURRENT_WORK_DAY_MU_RECEIVED_DATA":
            currentWorkDayDataMU = mapDayOverDay(action.currentWorkDayDataMU, state.previousWorkDayDataMU);
            return {
                ...state,
                currentWorkDayDataMU,
            };
        case "CURRENT_WORK_DAY_AGENT_RECEIVED_DATA":
            currentWorkDayDataAgent = mapDayOverDay(action.currentWorkDayDataAgent, state.previousWorkDayDataAgent);
        return {
            ...state,
            currentWorkDayDataAgent,
        };
        case "CURRENT_WORK_DAY_TEAM_RECEIVED_DATA":
            currentWorkDayDataTeam = mapDayOverDay(action.currentWorkDayDataTeam, state.previousWorkDayDataTeam);
        return {
            ...state,
            currentWorkDayDataTeam,
        };
        case "PREVIOUS_WORK_DAY_MU_RECEIVED_DATA":
            currentWorkDayDataMU = mapDayOverDay(state.currentWorkDayDataMU, action.previousWorkDayDataMU);
            return {
                ...state,
                currentWorkDayDataMU,
                previousWorkDayDataMU: action.previousWorkDayDataMU
            };
        case "PREVIOUS_WORK_DAY_AGENT_RECEIVED_DATA":
            currentWorkDayDataAgent = mapDayOverDay(state.currentWorkDayDataAgent, action.previousWorkDayDataAcurrentWorkDayDataAgent);
            return {
                ...state,
                currentWorkDayDataAgent,
                previousWorkDayDataAgent: action.previousWorkDayDataAgent
            };
        case "PREVIOUS_WORK_DAY_TEAM_RECEIVED_DATA":
            currentWorkDayDataTeam = mapDayOverDay(state.currentWorkDayDataTeam, action.previousWorkDayDataAcurrentWorkDayDataTeam);
            return {
                ...state,
                currentWorkDayDataTeam,
                previousWorkDayDataTeam: action.previousWorkDayDataTeam
            };
        case "THIRTY_DAY_AVERAGE_MU_RECEIVED_DATA":
            return {
                ...state,
                thirtyDayAverageDataMU: action.thirtyDayAverageDataMU
            };
        case "THIRTY_DAY_AVERAGE_AGENT_RECEIVED_DATA":
            return {
                ...state,
                thirtyDayAverageDataAgent: action.thirtyDayAverageDataAgent
            };
        case "THIRTY_DAY_AVERAGE_TEAM_RECEIVED_DATA":
            return {
                ...state,
                thirtyDayAverageDataTeam: action.thirtyDayAverageDataTeam
            };
        case "NotifySubscriberOfSelectedItems":
            return {
                ...state,
                muSelectedItems: action.muSelectedItems,
                teamSelectedItems: action.teamSelectedItems,
                agentSelectedItems: action.agentSelectedItems
                
            };
        case "DISPLAY_TABLE":
            return {
                ...state,
                displayTable: action.displayTable
            };
        case "CLEAR_TABLE":
            return {
                ...state,
                displayTable: action.displayTable
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/features/scorecard/redux/performance_metrics_grid_data_actions.js